import { render, staticRenderFns } from "./siteNavigation.vue?vue&type=template&id=8d299166&scoped=true&"
import script from "./siteNavigation.vue?vue&type=script&lang=js&"
export * from "./siteNavigation.vue?vue&type=script&lang=js&"
import style0 from "./siteNavigation.vue?vue&type=style&index=0&id=8d299166&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d299166",
  null
  
)

export default component.exports